export default __webpack_public_path__ + "static/media/DuerfpLightInActive.2d50f87b.svg";